/** Shared notification adapter. Sonner consumes this bounded queue at the app root. */
import { create } from 'zustand';
import type { FeedbackKind } from '@/lib/celebration';

export interface Toast {
  id: number;
  message: string;
  tone: 'error' | 'info' | 'success';
  feedback?: FeedbackKind;
}

interface ToastStore {
  toasts: Toast[];
  push: (message: string, tone?: Toast['tone'], feedback?: FeedbackKind) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastStore>((set) => ({
  toasts: [],
  push: (message, tone = 'info', feedback) =>
    set((s) => ({ toasts: [...s.toasts.slice(-9), { id: nextId++, message, tone, feedback }] })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export function useToast() {
  return useToastStore((s) => s.push);
}
